import { ConstantsLagoon } from '../../common/ConstantsLagoon';
import { getFeatureFlag } from '../../common/Utils';
import { returnSuppressFlag } from '../../utils/featureSuppress';
import { useLagoon } from '../useLagoon';

export const useWidgetSmartChoice = (
  isSmartChoiceEnabled: boolean,
  coverageType: string
) => {
  const featureFlags: [{ key: string; active: boolean }] =
    useLagoon('feature-flags')();

  const enablePSXProviderRecommendations = getFeatureFlag(
    featureFlags,
    ConstantsLagoon.FEATURE_FLAGS.ENABLE_PSX_PROVIDER_RECOMMENDATIONS
  );
  const isSmartChoiceSuppressed = returnSuppressFlag(
    ConstantsLagoon.FEATURE_SUPPRESSION_FLAGS.SMART_CHOICE
  );

  const baseCondition =
    !isSmartChoiceSuppressed &&
    enablePSXProviderRecommendations &&
    coverageType === 'M' &&
    isSmartChoiceEnabled;
  return baseCondition;
};
